export const AccountRoutes = {
  Login: "/auth/login",
  LoginInterstitial: "/auth/begin",
  Register: "/auth/register",
  RegisterSuccess: "/auth/check-your-email",
  AuthCallback: "/auth/callback",
  ConfirmEmail: "/auth/welcome",
  EmailSignIn: "/auth/email",
  EmailSignInSent: "/auth/email-sent",
  ForgotPassword: "/auth/forgot-password",
  ForgotPasswordSuccess: "/auth/verify",
  ResetPassword: "/auth/reset",
  Consent: "/consent",
  GettingStarted: "/getting-started",
  Account: "/account",
  ChangePassword: "/account/password",
  Organizations: "/account/organizations",
  OrganizationDetail: "/account/organizations/:id",
} as const;
